import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ReduxState } from 'ducks';

import { InquiryBookingSummary } from './InquiryBookingSummary';
import styles from './InquiryForm.module.css';
import { InquirySummary } from './InquirySummary';

export const InquirySubmitted = () => {
  const { t } = useTranslation();

  const supplierName = useSelector((state: ReduxState) => state.server.settings.all.supplier_name);

  React.useEffect(() => window.scrollTo(0, 0));

  return (
    <div className={styles['post-main__frame']}>
      <p className={styles['post-main__ttl']}>{t('Inquiry has been Submitted')}</p>

      <div className={styles['post-main__txt']}>
        {t(
          'Thank you for your inquiry. {{supplierName}} will review your submission and respond as soon as possible.',
          {
            supplierName,
          }
        )}
      </div>

      <p className={styles['post-main__subttl']}>
        {t('We sent you an email with your inquiry submission details')}
      </p>

      <InquiryBookingSummary />

      <InquirySummary />
    </div>
  );
};
